<div class="card p-4 mb-4 text-white">
  <form [formGroup]="searchForm" (ngSubmit)="fetchData()">
    <div class="row g-3 align-items-end">
      
      <!-- از تاریخ -->
      <div class="col-12 col-md-4 col-lg-3 position-relative">
        <label class="form-label mb-1">از تاریخ</label>
        <ng-persian-datepicker
          [uiTheme]="'gray'"
          [timeEnable]="false"
          [dateGregorianFormat]="'YYYY/MM/DD'"
          [dateInitValue]="true"
          [dateFormat]="'jYYYY/jMM/jDD'"
        >
          <input formControlName="strSDate" class="form-control text-end" dir="ltr" />
        </ng-persian-datepicker>
      </div>

      <!-- تا تاریخ -->
      <div class="col-12 col-md-4 col-lg-3 position-relative">
        <label class="form-label mb-1">تا تاریخ</label>
        <ng-persian-datepicker
          [uiTheme]="'gray'"
          [timeEnable]="false"
          [dateGregorianFormat]="'YYYY/MM/DD'"
          [dateInitValue]="true"
          [dateFormat]="'jYYYY/jMM/jDD'">
          <input formControlName="strEDate" class="form-control text-end" dir="ltr" />
        </ng-persian-datepicker>
      </div>

      <!-- دکمه جستجو -->
      <div class="col-12 col-md-4 col-lg-2">
        <button class="btn btn-primary w-100" type="submit">جستجو</button>
      </div>
      
      <!-- دکمه اکسل -->
      <div class="col-12 col-md-4 col-lg-2">
        <button class="btn btn-success w-100" (click)="exportExcel()">اکسل</button>
      </div>
      
    </div>
  </form>
  <div class="table-responsive border border-secondary mt-3">
    <table class="table table-hover table-striped table-dark rounded-3 text-center align-middle" id="Export_Excel">
      <thead class="thead-dark">
        <tr>
            <th scope="col" class="text-nowrap">#</th>
            <th scope="col" class="text-nowrap">تاریخ</th>
            <th scope="col" class="text-nowrap">روز</th>
            <th scope="col" class="text-nowrap">ساعت شروع</th>
            <th scope="col" class="text-nowrap">ساعت پایان</th>
            <th scope="col" class="text-nowrap">مدت فعالیت</th>
            <th scope="col" class="text-nowrap">میانگین ولتاژ</th>
            <th scope="col" class="text-nowrap">کمترین ولتاژ</th>
            <th scope="col" class="text-nowrap">بیشترین ولتاژ</th>
            <th scope="col" class="text-nowrap">میانگین جریان</th>
            <th scope="col" class="text-nowrap">کمترین جریان</th>
            <th scope="col" class="text-nowrap">بیشترین جریان</th>
            <th scope="col" class="text-nowrap">میانگین فرکانس</th>
            <th scope="col" class="text-nowrap">کمترین فرکانس</th>
            <th scope="col" class="text-nowrap">بیشترین فرکانس</th>
            <th scope="col" class="text-nowrap">تعداد افت ولتاژ</th>
            <th scope="col" class="text-nowrap">تعداد افزایش ولتاژ</th>
            <th scope="col" class="text-nowrap">تعداد افت فرکانس</th>
            <th scope="col" class="text-nowrap">تعداد افزایش فرکانس</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of reportVoltage; let i = index" class="f15">
            <td class="text-nowrap">{{ i + 1 | faNum }}</td>
            <td class="text-nowrap">{{ item.strDate | faNum }}</td>
            <td class="text-nowrap">{{ item.DayName }}</td>
            <td>{{ item.strSTime | faNum }}</td>
            <td>{{ item.strETime | faNum }}</td>
            <td>{{ item.strRunTimeSec | faNum }}</td>
            <td>{{ item.fAvgVoltage | faNum }}</td>
            <td>{{ item.fMinVoltage | faNum }}</td>
            <td>{{ item.fMaxVoltage | faNum }}</td>
            <td>{{ item.fAvgCurrent | faNum }}</td>
            <td>{{ item.fMinCurrent | faNum }}</td>
            <td>{{ item.fMaxCurrent | faNum }}</td>
            <td>{{ item.fAvgFrequency | faNum }}</td>
            <td>{{ item.fMinFrequency | faNum }}</td>
            <td>{{ item.fMaxFrequency | faNum }}</td>
            <td>{{ item.iLowVoltageCount | faNum }}</td>
            <td>{{ item.iHighVoltageCount | faNum }}</td>
            <td>{{ item.iLowFrequencyCount | faNum }}</td>
            <td>{{ item.iHighFrequencyCount | faNum }}</td>
        </tr>
        
        <tr *ngIf="!reportVoltage || reportVoltage.length === 0">
          <td colspan="19" class="text-center text-muted py-4">
            رکوردی برای نمایش یافت نشد.
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr class="text-center">
          <th colspan="5">جمع کل</th>
          <td>{{ strTotalRunTimeSec | faNum }}</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td>{{ totalLowVoltageCount | faNum }}</td>
          <td>{{ totalHighVoltageCount | faNum }}</td>
          <td>{{ totalLowFrequencyCount | faNum }}</td>
          <td>{{ totalHighFrequencyCount | faNum }}</td>
        </tr>
      </tfoot>
    </table>
  </div>
</div>
